exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".up-next-section__upNextCards__3JGAw {\n  margin: 0 auto;\n  max-width: 1250px;\n}\n.up-next-section__upNextCardList__28ABb {\n  display: flex;\n  flex-direction: column;\n}\n.up-next-section__upNextCardListItem__1YFIJ {\n  box-sizing: border-box;\n  position: relative;\n  will-change: max-height;\n}\n.up-next-section__upNextCardListItem__1YFIJ + .up-next-section__upNextCardListItem__1YFIJ {\n  padding-top: 16px;\n}\n.up-next-section__homeNoUpNextCards__124Xl {\n  margin-top: -24px;\n}\n", ""]);

// exports
exports.locals = {
	"upNextCards": "up-next-section__upNextCards__3JGAw",
	"upNextCardList": "up-next-section__upNextCardList__28ABb",
	"upNextCardListItem": "up-next-section__upNextCardListItem__1YFIJ",
	"homeNoUpNextCards": "up-next-section__homeNoUpNextCards__124Xl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2113/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/up-next-section.less
// module id = wzMc
// module chunks = 1